"use strict";
var dutyTemplate = require("../templates/duty.handlebars");
var restAPI = require('../restAPI.ts');
var seasons, compId, gameId, game, comp;
$("#dutyContainer").on('visible', function () {
    $("#dutyContainer").on('click', onClick);
    compId = $.bbq.getState("comp");
    gameId = $.bbq.getState("game");
    //$("#dutyContainer").on('click', onClick);  
    Promise.join(restAPI.getIndex(), restAPI.getComp(compId))
        .then(function (result) {
        comp = result[1];
        refresh();
    });
});
$("#dutyContainer").on('hidden', function () {
    $("#dutyWrapper").html("");
    $("#dutyContainer").off('click');
});
function refresh() {
    game = comp.gameLookup[gameId];
    var t1fixedPlayers = game.t1.corePlayers;
    t1fixedPlayers = t1fixedPlayers.concat(game.t1AssPlayers);
    t1fixedPlayers = _.uniq(t1fixedPlayers);
    var t1obj = {
        team: game.t1,
        homeAway: "Home",
        index: 1,
        fixedPlayers: t1fixedPlayers,
        goals: game.t1Score(),
        ga: game.t1GAScore,
        gs: game.t1GSScore
    };
    var t2fixedPlayers = game.t2.corePlayers;
    t2fixedPlayers = t2fixedPlayers.concat(game.t2AssPlayers);
    t2fixedPlayers = _.uniq(t2fixedPlayers);
    var t2obj = {
        team: game.t2,
        homeAway: "Away",
        index: 2,
        fixedPlayers: t2fixedPlayers,
        goals: game.t2Score(),
        ga: game.t2GAScore,
        gs: game.t2GSScore
    };
    var html = dutyTemplate({ comp: comp, game: game, t1obj: t1obj, t2obj: t2obj });
    $("#dutyWrapper").html(html);
    var affiliatesNums = _.map(game.t1.fillinPlayers, function (p) { return "" + p.affiliateNumber; });
    $("#affiliateInput" + game.t1.id)["typeahead"]({ hint: true, highLight: true, minLength: 1 }, { source: window["substringMatcher"](affiliatesNums) });
    affiliatesNums = _.map(game.t2.fillinPlayers, function (p) { return "" + p.affiliateNumber; });
    $("#affiliateInput" + game.t2.id)["typeahead"]({ hint: true, highLight: true, minLength: 1 }, { source: window["substringMatcher"](affiliatesNums) });
    var names = _.map(game.t1.fillinPlayers, function (p) { return "" + p.name; });
    $("#playerNameInput" + game.t1.id)["typeahead"]({ hint: true, highLight: true, minLength: 1 }, { source: window["substringMatcher"](names) });
    names = _.map(game.t2.fillinPlayers, function (p) { return "" + p.name; });
    $("#playerNameInput" + game.t2.id)["typeahead"]({ hint: true, highLight: true, minLength: 1 }, { source: window["substringMatcher"](names) });
}
function onClick(e) {
    if (e.target === undefined)
        return;
    if (e.target["id"] === undefined)
        return;
    var id = e.target["id"];
    if (id.indexOf("bbAddGoalSpan") !== -1)
        addGoal($(e.target.parentNode));
    else if (id.indexOf("bbAddGoal") !== -1)
        addGoal($(e.target));
    else if (id.indexOf("bbRemoveGoalSpan") !== -1)
        removeLastGoal($(e.target.parentNode));
    else if (id.indexOf("bbRemoveGoal") !== -1)
        removeLastGoal($(e.target));
    else if (id.indexOf("bbUpdateGameState") !== -1)
        updateGameState($(e.target));
}
function addGoal($target) {
    var teamId = $target.data("team"), position = $target.data("position");
    restAPI.addGoal(compId, gameId, teamId, game.state, position)
        .then(function (game) {
        refresh();
    });
    console.log("Adding goal to team:" + teamId + " position: " + position);
}
function removeLastGoal($target) {
    var teamId = $target.data("team"), position = $target.data("position");
    restAPI.removeGoal(compId, gameId, teamId, position)
        .then(function (game) {
        refresh();
    });
    console.log("Removing goal from team:" + teamId);
}
function updateGameState($target) {
    var gameState = $target.data("state");
    for (var i = 1; i <= 4; i++) {
        if (i <= gameState)
            $("#bbUpdateGameState" + i).addClass("active").removeClass("currentQuater");
        else
            $("#bbUpdateGameState" + i).removeClass("active").removeClass("currentQuater");
    }
    $("#bbUpdateGameState" + gameState).addClass("currentQuater");
    console.log("Updating game state setting state to " + gameState);
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/forms/dutyForm.ts
 ** module id = 63
 ** module chunks = 1
 **/